function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 12c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 01-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    stroke: "#2F384C",
    fill: "none"
  }, props), _ref);
};

export default SvgComment;